import { Base } from "ui/Scripts/source/framework/base";
import { EnumHelper, EventState, EventUserState } from "ui/Scripts/source/models/enums";

export interface IEventListItem {
    id: string;
    date: number;
    name: string;
    userName: string;
    userCompanyName: string;
    description: string;
    state: EventState;
    userState: EventUserState;
    urgencyClassCode: string;
    urgencyClassColor: string;

    modifyDate: number;
    published: boolean;
    removable: boolean;
    imported: boolean;
    exported: boolean;
    isRead: boolean;
    locked: boolean;
    isTitle: boolean;
    titleClass: string;

    stateStr: string;
    pluralStateStr: string;
    getModifyDate(): number;
}

export class EventListItem implements IEventListItem {
    id: string;
    date: number;
    name: string;
    userName: string;
    userCompanyName: string;
    description: string;
    state: EventState;
    userState: EventUserState;
    urgencyClassCode: string;
    urgencyClassColor: string;
    modifyDate: number;
    published: boolean;
    removable: boolean;
    imported: boolean;
    exported: boolean;
    isRead: boolean;
    locked: boolean;
    isTitle: boolean;
    titleClass: string;

    stateStr: string;
    pluralStateStr: string;

    constructor();
    constructor(obj: IEventListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.date = obj && obj.date || null;
        this.name = obj && obj.name || "";
        this.userName = obj && obj.userName || "";
        this.userCompanyName = obj && obj.userCompanyName || "";
        this.description = obj && obj.description || "";
        this.state = obj && obj.state || EventState.Draft;
        this.userState = obj && obj.userState || EventUserState.NotHandler;
        this.urgencyClassCode = obj && obj.urgencyClassCode || "";
        this.urgencyClassColor = obj && obj.urgencyClassColor || "";
        this.isRead = obj && obj.isRead || false;
        this.locked = obj && obj.locked || false;
        this.imported = obj && obj.imported || false;
        this.exported = obj && obj.exported || false;
        this.removable = obj && obj.removable || false;
        this.published = obj && obj.published || false;

        this.modifyDate = obj && obj.modifyDate || null;
        this.published = obj && obj.published || false;
        this.removable = obj && obj.removable || false;
        this.isTitle = obj && obj.isTitle || false;
        this.titleClass = obj && obj.titleClass || "";

        this.stateStr = EnumHelper.EventStateToStr(this.state);
        this.pluralStateStr = EnumHelper.EventStateToPluralStr(this.state);
    }

    getModifyDate(): number {
        return this.modifyDate;
    }

    static getTitleEventListItem(name: string, titleClass: string): EventListItem {
        const result = new EventListItem();
        result.id = Base.getGuid();
        result.name = name;
        result.isTitle = true;
        result.titleClass = titleClass;
        return result;
    }
}